export enum OrderStatus {
    CANCELED = -1,
    PENDING = 0,
    PAID = 1,
    ACCEPTED = 2,
}
